import { useCallback } from 'react';
import EfImg from '@elem/ui/ef-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import moment from 'moment';
import EcoImg from 'eco-design/base/eco-img';
import EcoEmail from 'eco-design/elements/eco-email';
import styles from './index.module.scss';
import type { prodcutItemType } from './useProductList';
import { useProductList } from './useProductList';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const GoodsA = () => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.GoodsA');
    const { productList } = useProductList(locale);

    const [gap, setGap] = useState(16);

    const handleBuyNow = useCallback(
        (link: string) => {
            if (link) {
                try {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('buy_now')}`,
                    });
                } catch (e) {
                    console.log(e);
                }
                window.open(link, '_blank');
            }
        },
        [t],
    );

    const handleGtm = useCallback(
        (btnName: string) => {
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'product_detail_page',
                    list_name: t('title'),
                    button_name: btnName,
                });
            } catch (e) {
                console.log(e);
            }
        },
        [t],
    );

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 1024) {
                setGap(16);
            } else {
                setGap(24);
            }
        }
    }, []);

    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <div className="eco-conetent">
                <div className="product-email">
                    <div className="product-email-left">
                        <p className="product-email-title">{t('productlist_email_title')}</p>
                        <EcoEmail
                            contactListId={['611913972']}
                            defaultTermsCheck
                            fields={[
                                {
                                    id: '4423',
                                    type: 'single',
                                    value: 1,
                                    overwrite: true,
                                },
                                {
                                    id: '31',
                                    type: 'single',
                                    value: 1,
                                    overwrite: false,
                                },
                                {
                                    id: '11150',
                                    type: 'multiple',
                                    value: [19],
                                    overwrite: false,
                                },
                                {
                                    id: '12761',
                                    type: 'text',
                                    value: moment(new Date()).format('YYYY-MM-DD'),
                                    overwrite: false,
                                },
                            ]}
                            needTerms={false}
                            subscribeData={{
                                sector_name: t('title'),
                                entry_position: 4,
                            }}
                        />
                    </div>
                    <div className="product-email-right">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1745744076595/product-email.png" />
                    </div>
                </div>
            </div>

            <Swiper
                className="products"
                modules={[Navigation]}
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation
                onSlidePrevTransitionStart={() => {
                    handleGtm('Left switch');
                }}
                onSlideNextTransitionStart={() => {
                    handleGtm('Right switch');
                }}
            >
                {productList.length > 0 &&
                    productList?.map((item: prodcutItemType, k: number) => {
                        return (
                            <SwiperSlide className={`product item-${k + 1}`} key={k}>
                                <div className="item">
                                    <EfImg className="item-img" pc={item?.variantImg} h5={item?.variantImg} />
                                    <div className="text-container">
                                        <div className="title">{item?.title}</div>
                                    </div>
                                    <div className="price-container">
                                        <div className="price1">{item?.price}</div>
                                        <div className="price2">{item?.compareAtPrice}</div>
                                    </div>
                                    <div className="btn-buy" onClick={() => handleBuyNow(item?.link_buy)}>
                                        {t('buy_now')}
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
            </Swiper>
        </div>
    );
};

export default GoodsA;
